import React, {useEffect, useRef, useState} from 'react';
import {getD365Adjustments} from '../../api/d365Api';
import {AdjustmentsTable} from "./AdjustmentsTable";
import {Checkbox, Col, Input, PageHeader, Row} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import {PREFERRED_DATE_FORMAT} from "../../util/time";
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";

const Adjustments = ({upload}) => {
  const [records, setRecords] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [reference, setReference] = useState({});
  const [hideColumns, setHideColumns] = useState(true);
  const [loading, setLoading] = useState(false);
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);


  const load = async () => {
    try {
      setLoading(true);
      const dto = await getD365Adjustments(upload ? upload.ID : 0);
      setReference({
        documents: dto.documents,
        types: dto.types,
        workers: dto.workers
      });
      setRecords(dto.postings);
      setFiltered(dto.postings);
    } catch (e) {
      console.error(`Could not get Adjustments Upload #${upload.ID} : ${e}`);
    } finally {
      setLoading(false);
    }
  };

  const filter = (records, search) => {
    var lcSearch = _.toLower(search);
    setFiltered(
      _.chain(records)
        .filter(
          (i) =>
            search === "" ||
            _.includes(_.toLower(i.categoryCode), lcSearch) ||
            _.includes(_.toLower(i.projectCode), lcSearch) ||
            _.includes(_.toLower(i.employee), lcSearch) ||
            _.includes(_.toLower(reference.workers[i.d365workerId]), lcSearch) ||
            _.includes(_.toLower(i.workerId), lcSearch) ||
            _.includes(_.toLower(i.transactionId), lcSearch) ||
            _.includes(i.projectorAmount, lcSearch) ||
            _.includes(_.toLower(i.skippedReason), lcSearch) ||
            _.includes(moment(i.softCostDate).format(PREFERRED_DATE_FORMAT), lcSearch)
        ).value()
    );
  };

  const search = (text) => {
    filter(records, text)
  };

  const handleCheckbox = (t) => {
    setHideColumns(!t.target.checked)
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Row style={{marginBottom: 10}}>
        {!upload && (
          <Col span={24}>
            <PageHeader
              title="D365 Adjustments All Records"
              subTitle={`(${filtered.length} shown)`}
              style={{padding: 0}}
            />
          </Col>
        )}
        <Col span={16}>
          <Input
            style={{maxWidth: 400, marginRight: 10}}
            placeholder="Search"
            prefix={<SearchOutlined/>}
            onChange={(e) => search(e.target.value)}
            allowClear
          />
          {upload &&
            <span className="ant-page-header-heading-sub-title">
            ({filtered.length} shown)
          </span>
          }
        </Col>
        <Col flex="auto">
          <Checkbox
            onChange={handleCheckbox}
            disabled={loading}
            style={{float: 'right'}}
          >
            Show Auditing
          </Checkbox>

        </Col>
      </Row>
      <AdjustmentsTable
        records={filtered}
        reference={reference}
        loading={loading}
        hideColumns={hideColumns}
        pagination={getPaginationConfig(filtered.length)}
        all={!upload}
        scroll={{y: tableHeight}}
      />
    </>
  );
};

export {Adjustments};